import { FormHelperText, IconButton, Link, Stack } from '@mui/joy';
import { useMutation } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import CrossIcon from '@/assets/icons/cross.svg?react';
import { SignImageCircle } from '@/components/processes/SignImage';
import { SignImageDto } from '@/modules/api';
import { backendApiSignImagesRemoveMutation } from '@/modules/api/@tanstack/react-query.gen';

type SignImageListProps = { signId: string; images: SignImageDto[]; disableDelete?: boolean };

export function SignImageList({ signId, images, disableDelete }: SignImageListProps) {
  const { processId } = useParams({ strict: false });

  const { mutate, error, isPending } = useMutation(backendApiSignImagesRemoveMutation());

  return (
    <Stack direction="row" gap={1}>
      {images?.map((image) => (
        <Stack key={image.id} direction="row">
          <Link href={`/api/sign-images/${signId}/images/${image.id}`} target="_blank" alignItems="flex-start">
            <SignImageCircle
              $size={(['md', 'md', 'sm', 'xs'] as const)[images.length] ?? 'xs'}
              alt="Hochgeladenes Bild"
              src={`/api/sign-images/${signId}/images/${image.id}`}
            />
            {!disableDelete && (
              <IconButton
                color="danger"
                disabled={isPending}
                onClick={(event) => {
                  event.preventDefault();
                  if (isPending) return;

                  mutate({ path: { signId, imageId: image.id }, query: { processId } });
                }}
                size="sm"
                sx={{
                  marginTop: -1.25,
                  marginLeft: -1.25,
                  borderRadius: '50%',
                  width: 20,
                  height: 20,
                  minWidth: 0,
                  minHeight: 0,
                }}
                title="Bilder entfernen"
                variant="solid"
              >
                <CrossIcon height={16} width={16} stroke="white" />
              </IconButton>
            )}
          </Link>
        </Stack>
      ))}
      {error && <FormHelperText>{`Es ist ein Fehler aufgetreten (${error.message})`}</FormHelperText>}
    </Stack>
  );
}
